import { forwardRef } from 'react'
import { Button as MuiButton, type ButtonProps as MuiButtonProps } from '@mui/material'

export type ButtonProps = MuiButtonProps

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { disableElevation = true, variant = 'contained', ...props },
  ref,
) {
  return <MuiButton ref={ref} disableElevation={disableElevation} variant={variant} {...props} />
})
